import { documentConfigs, ENROLLMENT_YEAR } from "../Formularios/documentConfig";

export const V2_ENROLLMENT_YEAR = ENROLLMENT_YEAR;
export const V2_DOCUMENTS = Object.fromEntries(
  Object.entries(documentConfigs).map(([key, config]) => [
    key,
    {
      ...config,
      description:
        "Completá los datos y revisá el documento original antes de imprimirlo o guardarlo como PDF.",
    },
  ])
);
